module.exports = __webpack_public_path__ + "static/media/1.08973e6d.JPG";